import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=377715a3&scoped=true&"
import script from "./addEvent.vue?vue&type=script&lang=js&"
export * from "./addEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377715a3",
  null
  
)

export default component.exports